<template>
    <v-stepper v-model="step">
        <v-stepper-header>
            <v-stepper-step :complete="step > 1" step="1">Share ke media sosial</v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="step > 2" step="2">Upload bukti sharing</v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="3">Menunggu akun aktif</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
            <sharing-information-step
                @nextStep="step = 2"
                step="1"
                :payment="payment"
            >
            </sharing-information-step>

            <proof-step
                @nextStep="step = 3"
                @prevStep="step = 1"
                step="2"
            >
            </proof-step>

            <free-post-waiting step="3"></free-post-waiting>
        </v-stepper-items>
    </v-stepper>
</template>

<script>
import SharingInformationStep from './SharingInformationStep'
import ProofStep from './ProofStep'
import FreePostWaiting from '@/components/dashboard/payment/FreePostWaiting'

export default {
    components: {
        SharingInformationStep,
        ProofStep,
        FreePostWaiting,
    },

    props: {
        payment: {
            type: Object
        }
    },

    data() {
        return {
            step: 1
        }
    },

    created() {
        if (this.payment.payment_proof) {
            this.step = 3
        }
    }
}
</script>
